export const PAGE_SIZE = 50;
export const LIST_LIMIT_MAX = 100;

export const OPERATION_TYPES = {
  PUBLISH_MASTER_DIRECTLY: 'PUBLISH_MASTER_DIRECTLY',
  PUBLISH_DRAFTS: 'PUBLISH_DRAFTS',
  ARCHIVE_CHANNEL_RECORDS: 'ARCHIVE_CHANNEL_RECORDS',
  DELETE_FROM_CHANNEL: 'DELETE_FROM_CHANNEL',
  DELETE_MASTER_AND_CHANNEL_RECORDS: 'DELETE_MASTER_AND_CHANNEL_RECORDS',
  DELETE_VARIANTS_AND_CHANNEL_RECORDS: 'DELETE_VARIANTS_AND_CHANNEL_RECORDS',
  OVERWRITE_DRAFTS_FROM_MASTER: 'OVERWRITE_DRAFTS_FROM_MASTER',
  OVERWRITE_DRAFTS_FROM_LIVE: 'OVERWRITE_DRAFTS_FROM_LIVE',
};

export const API_LIST_STATUSES = ['queued', 'running', 'completed', 'failed'];

export const RESULT = {
  queued: 'queued',
  running: 'running',
  success: 'success',
  warnings: 'warnings',
  partial_failure: 'partial_failure',
  failed: 'failed',
};

export const FILTER = {
  all: 'all',
  queued: 'queued',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
};

export const BATCH_OPERATION_LIVE_SOCKET_EVENTS = [
  'products.batchOperation.queued',
  'products.batchOperation.running',
  'products.batchOperation.progress',
];

export const BATCH_OPERATION_SOCKET_EVENTS = [
  'products.publishDirectly.complete',
  'products.publishDirectly.failed',
  'products.publishListing.complete',
  'products.publishListing.failed',
  'products.archiveListing.complete',
  'products.archiveListing.failed',
  'products.deleteFromChannel.complete',
  'products.deleteFromChannel.failed',
  'products.deleteMaster.complete',
  'products.deleteMaster.failed',
  'products.deleteVariants.complete',
  'products.deleteVariants.failed',
  'products.overwriteDrafts.complete',
  'products.overwriteDrafts.failed',
];
